<template>
  <v-container id="contact-grid" grid-list-xl>
    <!-- contact breadcrumb -->

    <v-snackbar
      v-model="editSnackbar"
      :color="editSnackbarColor"
      :timeout="15000"
      style="z-index: 1800"
      :top="true"
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-btn
      row
      v-show="!new_ticket"
      align-left
      class="mx-3 mt-2 mb-5"
      color="default"
      @click="new_ticket = true"
    >
      <v-icon right>mdi-plus</v-icon>
      {{ $t("ask_ticket") }}
    </v-btn>

    <v-form
      ref="form"
      v-show="new_ticket == true"
      row
      justify-center
      align-center
      class="mt-4"
    >
      <v-text-field
        filled
        dense
        name="codeDemand"
        color="blue-grey--text"
        v-model="codeDemand"
        :error-messages="codeErrors"
        :label="this.getLocaleMessages['codeDemand']"
        required
        @blur="$v.codeDemand.$touch()"
      ></v-text-field>
      <v-textarea
        color="blue-grey--text"
        filled
        dense
        required
        :eror-mressages="bodyErrors"
        v-model="body"
        :label="this.getLocaleMessages['comment']"
        name="body"
        @blur="$v.body.$touch()"
      ></v-textarea>
      <v-col cols="12" sm="12">
        <v-btn
          small
          class="mr-4 my-4"
          color="error"
          @click="
            resetForm();
            new_ticket = false;
            editSnackbar = false;
          "
          >{{ $t("close_btn") }}

          <v-icon right dark> mdi-close-circle </v-icon>
        </v-btn>
        <v-btn
          small
          @click="submit"
          color="green"
          class="white--text mr-4 my-4"
          :loading="isLoading"
          :disabled="this.$v.$invalid"
          >{{ $t("contact_btn") }}
          <v-icon right dark> mdi-chat-outline </v-icon>
        </v-btn>
      </v-col>
    </v-form>
    <v-container row justify-center align-center class="mx-auto mt-4 pt-2 m-0">
      <h3 class="blue-grey--text darken-1 text-center pb-4 m-3">
        {{ $t("ticket_title") }}
      </h3>
      <v-flex xs12 sm12 md12 lg12 xl12 class="mb-5">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Rechercher"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="alltickets" :search="search">
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                small
                v-if="item.cloturer == 0"
                class="mr-2"
                @click="clotureTickets(item)"
              >
                mdi-lock
              </v-icon>
              <span v-if="item.cloturer == 1"> {{ "Cloturé" }} </span>
            </template>

            <template v-slot:no-data>
              <v-col>
                <i style="font-size: 30px" class="fa-solid fa-circle-info"></i>
                <p>{{ $t("no_data") }}</p>
              </v-col>
              <v-col>
                <v-btn text color="primary" @click="getTickets">
                  {{ $t("btn_reset") }}
                </v-btn>
              </v-col>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-container>
  </v-container>
</template>

<script>
import img from "../../public/contact.png";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required, email, helpers } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  name: "Ticket",
  mixins: [validationMixin],
  validations: {
    codeDemand: { required },
    body: { required },
  },
  data() {
    return {
      img: img,
      isLoading: false,
      codeDemand: "",
      body: "",
      new_ticket: false,
      snackbarColor: "default",
      snackbar: false,
      editSnackbar: false,
      editSnackbarColor: "default",
      snackbar_text: "",
      search: "",
      alltickets: [],
      headers: [
        {
          text: "N° Ticket",
          align: "start",
          filterable: false,
          value: "id",
        },
        { text: "Raison", value: "raison" },
        { text: "Date de création", value: "created_at" },
        { text: "Date de dernière mise à jours", value: "updated_at" },
        { text: "Action", value: "action" },
      ],
    };
  },
  created() {
    this.$store.dispatch("setCurrentRoute", this.$route.name);
    this.$root.$i18n.locale = this.langLocal;
    this.getTickets();
    moment.locale(this.langLocal);
  },
  methods: {
    format_date(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY HH:mm:ss");
      }
    },

    async getTickets() {
      await this.$store
        .dispatch("getListesTickets")
        .then((response) => {
          response.forEach((demand) => {
            demand.created_at = this.format_date(demand.created_at);
            demand.updated_at = this.format_date(demand.updated_at);
          });

          this.alltickets = response;

          console.log(this.alltickets);
        })
        .catch((error) => {});
    },

    async submit() {
      this.isLoading = true;
      this.editSnackbar = false;
      let data = new FormData();
      data.append("codeDemand", this.codeDemand);
      data.append("message", this.body);
      if (!this.$v.$invalid) {
        await this.$store
          .dispatch("ticket", data)
          .then((response) => {
            this.isLoading = false;
            this.resetForm();

            if (response.success && response.message != "relance") {
              this.editSnackbarColor = "success";
              this.snackbar_text = this.getLocaleMessages['ticket_wait'];
              this.editSnackbar = true;
            } else if (response.success && response.message == "relance") {
              this.editSnackbarColor = "red";
              this.snackbar_text =this.getLocaleMessages['ticket_alredy'];
              this.editSnackbar = true;
            } else {
              this.editSnackbarColor = "red";
              this.snackbar_text = this.getLocaleMessages['code_not_found'];
              this.editSnackbar = true;
            }
            this.getTickets();
          })
          .catch((error) => {
            this.editSnackbarColor = "red";
            this.snackbar_text = this.getLocaleMessages['erreur_produit'];
            this.editSnackbar = true;
          });
      }
    },

    async clotureTickets(item) {
      this.isLoading = true;
      this.editSnackbar = false;
      let data = new FormData();
      data.append("id", item.id_demande);

      await this.$store
        .dispatch("cloturer_ticket", data)
        .then((response) => {
          this.isLoading = false;
          this.getTickets();

          console.log(response);
        })
        .catch((error) => {
          this.editSnackbarColor = "red";
          this.snackbar_text = this.getLocaleMessages['erreur_produit'];
          this.editSnackbar = true;
        });
    },
    resetForm() {
      this.$v.$reset();
      this.code = "";
      this.body = "";
    },
  },
  watch: {
    langLocal(val) {
       (moment.localeval);
    },
  },
  computed: {
    getLocaleMessages() {
      return this.$root.$i18n.messages[this.langLocal];
    },
    codeErrors() {
      const errors = [];
      if (!this.$v.codeDemand.$dirty) return errors;
      !this.$v.codeDemand.required &&
        errors.push(this.getLocaleMessages["required_codeDemand"]);                       
      return errors;
    },
    bodyErrors() {
      const errors = [];
      if (!this.$v.body.$dirty) return errors;
      !this.$v.body.required &&
        errors.push(this.getLocaleMessages["required_comment"]);
      return errors;
    },
    ...mapGetters(["current_route", "langLocal"]),
  },
};
</script>

<style lang="scss" scoped>
#f-contact {
  padding: 20px;
}
#s-contact {
  padding: 20px;
}
#contact-grid {
  margin-top: 120px;
  width: 100%;
  min-height: 70vh;
}
.contact-img {
  max-width: 100%;
}
.w3l-footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 100;
  width: 100%;
}

@media (max-width: 700px) {
  #f-contact {
    display: none;
  }
}
</style>